export const getSafeFileName = ({ end = 100, name, start = 0 }: { end?: number; name: string; start?: number }) => {
  if (name.length <= end) {
    return name;
  }

  // eslint-disable-next-line unicorn/prefer-string-replace-all -- TODO: replace with replaceAll when upgrading to newer sandokan, also delete from regex gi
  const safeName = name.replace(/[^\da-z]/gi, '_');

  return `${safeName.slice(start, end)}...`;
};
